import { render, staticRenderFns } from "./LabsTable.vue?vue&type=template&id=fe4d16d0"
import script from "./LabsTable.vue?vue&type=script&lang=js"
export * from "./LabsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports